module.exports = __webpack_public_path__ + "static/media/twitch.14833396.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/socialIcons/twitch.png
// module id = 724
// module chunks = 0